module.exports = __webpack_public_path__ + "img/cb75537.webp";